import React, { useState } from "react";
import Chevron from "../Chevron/Chevron";
import styles from "./ExpandableWidget.module.sass";
const ExpandableWidget = props => {
  const {
    title,
    children,
    className
  } = props;
  const [expanded, setExpanded] = useState(false);
  const actionLabel = expanded ? /*#__PURE__*/React.createElement(Chevron, {
    direction: "down"
  }) : /*#__PURE__*/React.createElement(Chevron, {
    direction: "right"
  });
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles["root"]} ${className} ${expanded ? "" : styles["collapsed"]}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `widget-title ${styles["header"]}`,
    onClick: () => {
      setExpanded(!expanded);
    }
  }, /*#__PURE__*/React.createElement("h4", {
    className: styles["title"]
  }, title), /*#__PURE__*/React.createElement("button", {
    className: styles["button"]
  }, /*#__PURE__*/React.createElement("small", null, actionLabel))), expanded && children);
};
export default ExpandableWidget;